import React from 'react';
import cx from 'classnames';
import { MDText } from 'i18n-react';

import { VideoPoster } from 'Components/StaticPages/ProductPageComponents/VideoPoster/VideoPoster';
import { useBreakpoint } from 'Context/BreakpointsContext/BreakpointsContext';

import LocalTexts from '../DiscoverMWPay.texts.json';

import { useVideoModal } from './VideoModal/useVideoModal';
import { VideoModal } from './VideoModal/VideoModal';

import styles from './FAQSection.module.scss';

const LocalT = new MDText(LocalTexts);

const YOUTUBE_VIDEO_ID = `Uz04m9f0hp8`;

export const FAQTestimonialVideo: React.FC = () => {
	const {
		closeModal: closeVideoModal,
		openModal: onClick,
		state: isVideoModalOpen,
	} = useVideoModal({ eventName: 'Payments testimonial video modal clicked' });

	const {
		minWidth: { breakpointTablet: isDesktop },
	} = useBreakpoint();

	return (
		<>
			<section className={styles.faqTestimonialVideo}>
				<div className={cx(styles.container)}>
					<VideoPoster
						alt={LocalT.translate('faq.testimonials.p1') as string}
						onClick={onClick}
						orientation={isDesktop ? 'all' : 'top'}
						showPlayButton={true}
						youtubeVideoId={YOUTUBE_VIDEO_ID}
					/>
					<div className={styles.text}>
						<h3>{LocalT.translate('faq.testimonials.heading')}</h3>
						<p>{LocalT.translate('faq.testimonials.p1')}</p>
					</div>
				</div>
			</section>
			{isVideoModalOpen && <VideoModal dismissModal={closeVideoModal} youtubeVideoId={YOUTUBE_VIDEO_ID} />}
		</>
	);
};
